import { render, staticRenderFns } from "./tab10.vue?vue&type=template&id=a02335da&scoped=true&"
import script from "./tab10.vue?vue&type=script&lang=js&"
export * from "./tab10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02335da",
  null
  
)

export default component.exports